// extracted by mini-css-extract-plugin
module.exports = {"root":"fncButton_root__1fBxn","isSecondary":"fncButton_isSecondary__3MLwt","isCancel":"fncButton_isCancel__xX1vj","fullWidth":"fncButton_fullWidth__Jqhju"};